import axios from '../../apis/apicidtech';
import { types } from '../../types/types';
import { getToken } from '../../utils/tokencidtechapi';
import { dispatchpending, dispatchresponse, dispatchresponseerror } from '../utils/dispatches';

export const novoatualiza = (dados = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.post('helpers/uploads/novoatualiza',dados,
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`,
                        //'Content-Type': 'multipart/form-data'
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data,types.UPLOAD.NOVOATUALIZA);

            return response.data;

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const pesquisa = (filtro = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);
        
        try{
            const response = await axios.get('helpers/uploads/pesquisa',
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    },
                    params:{
                        ...filtro
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data?response.data:{},types.UPLOAD.PESQUISAUPLOADS);

            return response.data?response.data:{};

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const deletar = (dados = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.put('helpers/uploads/deletar',dados,
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`                        
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data,types.UPLOAD.DELETAR);

            return response.data;

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}